import template from 'core/service/pdf-generation/products/bumnan-ready/template'
import { section } from 'core/service/pdf-generation/products/bumnan-ready/sections'
import { commonSection } from 'core/service/pdf-generation/products/common/sections'
import { createPdfDocument } from 'core/service/pdf-generation/document-creation'
import { createCommonPdf } from '../common/pdf-document'
import { basicPlanDetailsLabelFn } from 'core/service/pdf-generation/products/bumnan-ready/sections/product-benefit-section'
import VALUES from 'core/data-model/constants/values'

const getProfileProps = (props) => {
  return {
    basicPlanLabel: (displayProduct) => displayProduct.nameThai,
  }
}

const getProductBenefitsProps = (props) => {
  return {
    basicPlanDetailsLabelFn,
  }
}

export const createMiniBIDocDefinition = async (props) => {
  const pdfTemplate = await template(props)

  return {
    content: [
      ...commonSection.profile({ ...props, ...getProfileProps(props) }),
      ...commonSection.productBenefits({ ...props, ...getProductBenefitsProps(props) }),
      ...commonSection.riders(props),
      ...section.policyValueTable(props),
      section.benefitSummary(props),
      section.taxDeductionBenefit(props),
      commonSection.legalDisclaimerMarketConduct(props),
    ],
    ...pdfTemplate,
  }
}

export const createFullBIDocDefinition = async (props) => {
  const pdfTemplate = await template({ ...props, biType: props.biType })
  const paymentChannels = await commonSection.paymentChannels(props)
  const findContentByProduct = (productCode) => {
    if (VALUES.BUMNAN_SMART_GROUP.includes(productCode)) {
      return [
        section.profileSnapshot(props),
        section.productBenefits({ ...props, ...getProductBenefitsProps(props) }),
        ...commonSection.riders(props),
        section.basicPlanCondition(),
        section.policyValueTableBumnanSmart(props),
        section.benefitSummaryBumnanSmart(props),
        commonSection.taxGioRetirementDeductionBenefit(props),
        commonSection.legalDisclaimerMarketConductNoAddtionalContract(props),
        paymentChannels,
        commonSection.signature(props),
      ]
    }
    return [
      section.profileSnapshot(props),
      //...commonSection.profile({ ...props, ...getProfileProps(props) }),
      section.productBenefits({ ...props, ...getProductBenefitsProps(props) }),
      ...commonSection.riders(props),
      section.basicPlanCondition(),
      section.policyValueTable(props),
      section.benefitSummary(props),
      section.taxDeductionBenefit(props),
      commonSection.legalDisclaimerMarketConduct(props),
      paymentChannels,
      commonSection.signature(props),
    ]
  }

  return {
    content: findContentByProduct(props.basicPlan.basicPlanCode),
    ...pdfTemplate,
  }
}

const createFullBIPdf = createPdfDocument(createFullBIDocDefinition)
const createMiniBIPdf = createPdfDocument(createMiniBIDocDefinition)

export const createBumnanReadyPdf = async (props) => {
  return await createCommonPdf(props, createFullBIPdf, createMiniBIPdf)
}
